const getMaxOptionForUserToSelect = (rangeMax, increment) => {
  const remainder = rangeMax % increment;
  const maxOptionForUserToSelect =
    rangeMax + (remainder === 0 ? 0 : increment - remainder);
  return maxOptionForUserToSelect;
}

const getMaxSelectionOptions = (appliedRange, range, increment) => {
  const maxOptions = [];
  const maxOptionForUserToSelect = getMaxOptionForUserToSelect(range.max, increment);
  const minOptionForUserToSelect = appliedRange?.min ?? range.min;

  for (let i = maxOptionForUserToSelect, l = minOptionForUserToSelect; i > l; i -= increment) {
    maxOptions.push(`${i}`);
  }

  return maxOptions;
};

export default getMaxSelectionOptions;
